import React, { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { FileX2, Loader2 } from "lucide-react";

export function RejectContractDialog({ user, onDone }) {
  const [open, setOpen] = useState(false);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      await api.post(`/admin/users/${user.id}/reject-contract`, { note });
      toast.success("تم رفض العقد وإرسال الملاحظة");
      setOpen(false); setNote("");
      onDone();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" variant="outline" className="h-8 rounded-lg gap-1 text-destructive border-destructive/30" data-testid={`reject-contract-${user.id}`}>
          <FileX2 className="w-3.5 h-3.5" /> رفض العقد
        </Button>
      </DialogTrigger>
      <DialogContent dir="rtl" data-testid="reject-contract-dialog">
        <DialogHeader><DialogTitle>رفض العقد المرفوع — {user.name}</DialogTitle></DialogHeader>
        <Textarea rows={4} value={note} onChange={(e) => setNote(e.target.value)} maxLength={1000}
          placeholder="اكتب سبب الرفض، مثلاً: التوقيع غير واضح أو الختم ناقص" data-testid="reject-contract-note" />
        <p className="text-xs text-muted-foreground">تصل الملاحظة لصاحب الحساب بإشعار وبالبريد، ويقدر يرفع العقد من جديد.</p>
        <DialogFooter>
          <Button variant="destructive" className="rounded-xl gap-2 w-full" disabled={busy || note.trim().length < 3} onClick={submit} data-testid="reject-contract-submit">
            {busy && <Loader2 className="w-4 h-4 animate-spin" />} رفض وإرسال الملاحظة
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
